import React from 'react'
import styles from '../styles.module.css'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { date } from 'yup'

const Table = ({ data, reportParams, length }) => {

  const { year, idOrg } = reportParams
    
  const orgList = useSelector(state => state.reports.orgList.data)

  const org = orgList.find(org => org.idOrganization == idOrg)
  
  if (!data) return null;
  
  const renderRow = (student, index) => {
    const fizoGrade = student.fizo_grade ? `(балл - ${student.fizo_grade})` : ''
    
    const dateFormatted = (date) => date ? moment(date, 'DD.MM.YYYY h:mm:ss').format('DD.MM.YYYY') : null
    const dateFormatted2 = (date) => date ? moment(date).format('DD.MM.YYYY') : null

    return (
      <tr>
        <td>{index + 1}</td>
        <td>{student.fio}</td>
        <td>{student.VUZDlaPostupleniya}</td>
        <td>{student.spetsialnost}</td>
        <td>{dateFormatted2(student.lichnoe_delo)}</td>
        {/* <td>{student.lichnoe_delo}</td> */}
        <td>{dateFormatted(student.send_date)}</td>
        <td>{dateFormatted(student.receive_date)}</td>
        <td>{student.rezultat_profobora}</td>
        <td>{student.profobor}</td>
        <td>{student.rezultat_fizo} {fizoGrade}</td>
        <td>{}</td>
      </tr>
    )
  }

  return (
    <div className={styles.tableBlock}>

          {data.map(el => (
            <React.Fragment key={el[0].idorganization}>
              <h3 className={"text-right mt-5 mb-2"}>Общее количество выпускников - {el.length}</h3>

            <h3 className={"text-center mb-2 mt-5"}>Список выпускников</h3>
                <h3 className={"text-center mb-2"}>{el[0].orgname},</h3>
                <h3 className={"text-center mb-2"}>{`поступающих в высшие военно-учебные заведения в ${year} году`}</h3>
          <table id={`graduatesTable_${el[0].idorganization}`} className={styles.mainTable}>
              <thead>
                <tr>
                  <th rowSpan={2}>№ п/п</th>
                  <th rowSpan={2}>Фамилия, имя, отчество выпускника</th>
                  <th rowSpan={2}>Наименование высшего военно-учебного заведения</th>
                  <th rowSpan={2}>Специальность</th>
                  <th colSpan={6}>Выполненные мероприятия</th>
                  <th rowSpan={2}>Примечание</th>
                </tr>
                <tr>
                  <th>Оформление личного дела</th>
                  <th>Личное дело направлено в вуз</th>
                  <th>Личное дело получено вузом</th>
                  <th>Прохождение ВВК</th>
                  <th>Прохождение профотбора</th>
                  <th>Сдача физической подготовки</th>
                </tr>
              </thead>
              <tbody>
              {el.map((student, index) => renderRow(student, index))}
              </tbody>
              </table>
            </React.Fragment>
          ))}
    </div>
  )
}

export default Table